module.exports = "/images/logo-djp-9cc58e5c8c8aae20ceda4a7556dfd4fa.png";